(() => {
  'use strict';
  let controller;
  let observers=[];
  const initialize=()=>{
  controller?.abort();
  observers.forEach(observer=>observer.disconnect());observers=[];
  controller=new AbortController();
  const themeId = document.body.dataset.themeId;
  const previewMode = document.body.dataset.previewMode === 'true';
  const labels = JSON.parse(document.getElementById('sandbox-labels')?.textContent || '{}');
  const say = key => labels[key] || key;
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100);
  const safe = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const previewUrl = (path, params = {}) => {
    const url = new URL(path, location.origin);
    if (previewMode && url.origin === location.origin) url.searchParams.set('preview_theme_id', themeId);
    Object.entries(params).forEach(([key,value]) => url.searchParams.set(key,value));
    return url.href;
  };
  document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href,location.origin);
    if(url.origin === location.origin && !url.pathname.startsWith('/cdn/') && !url.pathname.startsWith('/customer')) {
      const oldCategory=url.searchParams.get('category');
      if(url.pathname==='/collections/all'&&oldCategory){url.searchParams.delete('category');url.searchParams.set('view','otey-'+oldCategory);}
      if(previewMode && !url.pathname.startsWith('/checkout')) url.searchParams.set('preview_theme_id',themeId);
      link.href = url.href;
    }
  });
  const menu = document.querySelector('.menu-toggle');
  menu?.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));document.querySelector('.site-header').classList.toggle('menu-open',open);},{signal:controller.signal});
  document.addEventListener('click',event=>{if(!event.target.closest('.nav-dropdown'))document.querySelectorAll('.nav-dropdown[open]').forEach(menu=>menu.open=false);},{signal:controller.signal});
  document.querySelectorAll('.nav-dropdown').forEach(dropdown=>dropdown.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dropdown.open=false;dropdown.querySelector('summary').focus();}},{signal:controller.signal}));
  document.querySelectorAll('[data-close-dialog]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close(),{signal:controller.signal}));
  document.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();},{signal:controller.signal}));
  document.querySelectorAll('[data-open-guide]').forEach(button=>button.addEventListener('click',()=>document.getElementById('length-guide').showModal(),{signal:controller.signal}));
  const galleryButtons=[...document.querySelectorAll('[data-gallery-image]')];
  const mainPhoto=document.getElementById('main-product-image');
  const photoDialog=document.getElementById('product-photo-dialog');
  let galleryIndex=0;
  const setPhoto=index=>{
    if(!galleryButtons.length||!mainPhoto)return;
    galleryIndex=(index+galleryButtons.length)%galleryButtons.length;
    const button=galleryButtons[galleryIndex];
    mainPhoto.src=button.dataset.galleryImage;
    mainPhoto.srcset=button.dataset.gallerySrcset;
    mainPhoto.alt=button.dataset.galleryAlt;
    galleryButtons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    document.querySelectorAll('[data-gallery-counter]').forEach(el=>el.textContent=`${galleryIndex+1} / ${galleryButtons.length}`);
    if(photoDialog?.open){const zoom=photoDialog.querySelector('[data-zoom-image]');zoom.src=button.dataset.galleryImage;zoom.alt=button.dataset.galleryAlt;}
  };
  galleryButtons.forEach((button,index)=>button.addEventListener('click',()=>setPhoto(index),{signal:controller.signal}));
  document.querySelectorAll('[data-gallery-prev]').forEach(button=>button.addEventListener('click',()=>setPhoto(galleryIndex-1),{signal:controller.signal}));
  document.querySelectorAll('[data-gallery-next]').forEach(button=>button.addEventListener('click',()=>setPhoto(galleryIndex+1),{signal:controller.signal}));
  let swipeStart=null,ignorePhotoClickUntil=0;
  const galleryTarget=document.querySelector('[data-open-zoom]');
  galleryTarget?.addEventListener('pointerdown',event=>{swipeStart={x:event.clientX,y:event.clientY};},{signal:controller.signal});
  galleryTarget?.addEventListener('pointercancel',()=>{swipeStart=null;},{signal:controller.signal});
  galleryTarget?.addEventListener('pointerup',event=>{
    if(!swipeStart)return;
    const dx=event.clientX-swipeStart.x,dy=event.clientY-swipeStart.y;swipeStart=null;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){setPhoto(galleryIndex+(dx<0?1:-1));ignorePhotoClickUntil=performance.now()+400;}
  },{signal:controller.signal});
  galleryTarget?.addEventListener('click',()=>{
    if(performance.now()<ignorePhotoClickUntil||!photoDialog)return;
    const zoom=photoDialog.querySelector('[data-zoom-image]');zoom.src=mainPhoto.currentSrc||mainPhoto.src;zoom.alt=mainPhoto.alt;
    photoDialog.showModal();setPhoto(galleryIndex);
  },{signal:controller.signal});
  photoDialog?.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();setPhoto(galleryIndex-1);}if(event.key==='ArrowRight'){event.preventDefault();setPhoto(galleryIndex+1);}},{signal:controller.signal});
  document.querySelector('[data-photo-magnify]')?.addEventListener('click',event=>{
    const magnified=event.currentTarget.getAttribute('aria-pressed')!=='true';
    event.currentTarget.setAttribute('aria-pressed',String(magnified));event.currentTarget.textContent=say(magnified?'zoom_out':'zoom_in');photoDialog.querySelector('.photo-stage').classList.toggle('magnified',magnified);
  },{signal:controller.signal});
  photoDialog?.addEventListener('close',()=>{photoDialog.querySelector('.photo-stage').classList.remove('magnified');const button=photoDialog.querySelector('[data-photo-magnify]');button.setAttribute('aria-pressed','false');button.textContent=say('zoom_in');},{signal:controller.signal});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.getAttribute('aria-expanded')==='true'){menu.setAttribute('aria-expanded','false');document.querySelector('.site-header').classList.remove('menu-open');menu.focus();}},{signal:controller.signal});
  const cards=[...document.querySelectorAll('.catalog-grid .product-card')];
  if(cards.length){
    let category=document.querySelector('.catalog-grid')?.dataset.collectionKey||'putters';
    if(!['putters','new','limited','accessories','headcovers','gifts','restoration'].includes(category)) category='putters';
    const search=document.getElementById('catalog-search');
    const shape=document.getElementById('shape-filter');
    const buttons=[...document.querySelectorAll('[data-filter]')];
    const filter=()=>{
      let count=0;
      cards.forEach(card=>{
        const matchCategory=true;
        const matchSearch=card.dataset.title.toLowerCase().includes(search.value.toLowerCase().trim());
        const matchShape=shape.value==='all'||category!=='putters'||card.dataset.shape===shape.value;
        card.hidden=!(matchCategory&&matchSearch&&matchShape);
        if(!card.hidden)count++;
      });
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===category)));
      document.querySelector('[data-result-count]').textContent=`${count} ${say('products')}`;
      document.getElementById('catalog-empty').hidden=count>0;
      shape.disabled=category!=='putters';
    };
    buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.filter;shape.value='all';const url=new URL(location.href);url.searchParams.set('category',category);history.replaceState(null,'',url.href);filter();},{signal:controller.signal}));
    search.addEventListener('input',filter,{signal:controller.signal});shape.addEventListener('change',filter,{signal:controller.signal});filter();
  }
  let discountBusy=false;
  const changeCartDiscount=async(removeCode=null)=>{
    const panel=document.querySelector('[data-cart-discount]');
    if(!panel||discountBusy)return;
    const input=panel.querySelector('[data-discount-input]');
    const status=panel.querySelector('[data-discount-status]');
    const entered=input.value.trim();
    const current=[...panel.querySelectorAll('[data-remove-discount]')].map(button=>button.dataset.removeDiscount);
    const normalize=value=>String(value).toUpperCase();
    const message=(text,error=false)=>{status.textContent=text;status.hidden=false;status.setAttribute('role',error?'alert':'status');};
    if(removeCode===null&&!entered){message(panel.dataset.emptyMessage,true);input.focus();return;}
    const codes=removeCode===null?[...new Set([...current.map(normalize),normalize(entered)])]:current.filter(code=>normalize(code)!==normalize(removeCode));
    const bag=panel.closest('.sandbox-bag');
    const quantities=[...bag.querySelectorAll('[name="updates[]"]')].map(el=>el.value);
    const controls=[...bag.querySelectorAll('button,input')].filter(el=>!el.disabled);
    const request=async(values)=>{
      const response=await fetch(panel.dataset.cartUrl+'/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({discount:values.join(','),sections:panel.dataset.sectionId,sections_url:location.pathname+location.search})});
      const data=await response.json();
      if(!response.ok)throw new Error('cart_discount_update_failed');
      return data;
    };
    discountBusy=true;controls.forEach(el=>el.disabled=true);panel.setAttribute('aria-busy','true');message(panel.dataset.loadingMessage);
    try{
      let data=await request(codes);
      let html=data.sections?.[panel.dataset.sectionId];
      let fragment=html?new DOMParser().parseFromString(html,'text/html').querySelector('.sandbox-bag'):null;
      const renderedCodes=fragment?[...fragment.querySelectorAll('[data-remove-discount]')].map(button=>normalize(button.dataset.removeDiscount)):[];
      const apiCodes=(data.discount_codes||[]).filter(code=>code.applicable!==false).map(code=>normalize(code.code));
      if(removeCode===null&&!renderedCodes.includes(normalize(entered))&&!apiCodes.includes(normalize(entered))){
        await request(current);message(panel.dataset.invalidMessage,true);input.setAttribute('aria-invalid','true');input.focus();return;
      }
      if(!fragment){location.reload();return;}
      fragment.querySelectorAll('a[href]').forEach(link=>link.href=previewUrl(link.getAttribute('href')));
      fragment.querySelectorAll('[name="updates[]"]').forEach((el,index)=>{if(quantities[index]!==undefined)el.value=quantities[index];});
      bag.replaceWith(fragment);
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=data.item_count);
      const nextPanel=fragment.querySelector('[data-cart-discount]');
      const nextStatus=nextPanel.querySelector('[data-discount-status]');
      nextStatus.hidden=false;nextStatus.textContent=removeCode===null?nextPanel.dataset.appliedMessage:nextPanel.dataset.removedMessage;
      nextPanel.querySelector('[data-discount-input]').focus({preventScroll:true});
    }catch{
      message(panel.dataset.errorMessage,true);
    }finally{
      discountBusy=false;controls.forEach(el=>el.disabled=false);panel.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click',event=>{
    const apply=event.target.closest('[data-apply-discount]');
    const remove=event.target.closest('[data-remove-discount]');
    if(apply||remove){event.preventDefault();changeCartDiscount(remove?remove.dataset.removeDiscount:null);}
  },{signal:controller.signal});
  document.addEventListener('keydown',event=>{
    if(event.key==='Enter'&&event.target.matches('[data-discount-input]')){event.preventDefault();changeCartDiscount();}
  },{signal:controller.signal});

  const productForm=document.querySelector('[data-product-form]');
  if(productForm){
    const variants=JSON.parse(document.getElementById('otey-product-variants').textContent);
    const select=productForm.querySelector('[name="id"]');
    const purchaseButton=productForm.querySelector('[data-purchase-button]');
    const mobileButton=document.querySelector('[data-mobile-buy]');
    const mobileBar=document.querySelector('[data-mobile-purchase]');
    const addLabel=purchaseButton.textContent.trim();
    const needsOptions=productForm.dataset.needsOptions==='true';
    const options=productForm.querySelector('.otey-options');
    const refreshStampingLabels=()=>{
      if(!options)return;
      const walker=document.createTreeWalker(options,NodeFilter.SHOW_TEXT);
      let node;
      while((node=walker.nextNode())){
        if(node.parentElement?.closest('script,style,textarea'))continue;
        const text=node.nodeValue.replace(/custom engraving/gi,'Personal Stamping').replace(/engraving/gi,'stamping');
        if(text!==node.nodeValue)node.nodeValue=text;
      }
    };
    refreshStampingLabels();
    if(options){const copyObserver=new MutationObserver(refreshStampingLabels);copyObserver.observe(options,{childList:true,subtree:true,characterData:true});observers.push(copyObserver);}
    const defaultClassicCover=()=>{
      if(!needsOptions||!options||productForm.dataset.classicCoverDefaulted==='true')return;
      const fields=[...options.querySelectorAll('.tcustomizer-field')];
      const field=fields.find(item=>{
        const values=[...item.querySelectorAll('input[type="radio"]')].map(input=>input.value);
        return values.length===3&&values.some(value=>/^Classic Headcover \(Included\)$/i.test(value))&&values.some(value=>/Wardrobe/i.test(value))&&values.some(value=>/Burke/i.test(value));
      });
      if(!field)return;
      const included=[...field.querySelectorAll('input[type="radio"]')].find(input=>/^Classic Headcover \(Included\)$/i.test(input.value));
      const label=[...field.querySelectorAll('label[for]')].find(item=>item.htmlFor===included.id);
      if(!label)return;
      productForm.dataset.classicCoverDefaulted='true';
      if(!label.classList.contains('selected')&&!included.checked)label.click();
    };
    defaultClassicCover();
    if(options){const coverObserver=new MutationObserver(defaultClassicCover);coverObserver.observe(options,{childList:true,subtree:true});observers.push(coverObserver);}
    let optionsReady=!needsOptions||Boolean(options?.querySelector('.tcustomizer-field'));
    const optionsStatus=productForm.querySelector('[data-options-status]');
    const updateVariant=()=>{
      const variant=variants.find(item=>String(item.id)===select.value);
      if(!variant)return;
      document.querySelectorAll('[data-product-price],[data-configured-total],[data-mobile-total]').forEach(el=>el.textContent=variant.price);
      productForm.querySelectorAll('[data-purchase-button]').forEach(button=>{button.disabled=!variant.available||!optionsReady;button.textContent=variant.available?addLabel:say('unavailable');});
      if(mobileButton){mobileButton.disabled=!variant.available||!optionsReady;mobileButton.textContent=purchaseButton.textContent;}
    };
    select?.addEventListener('change',updateVariant,{signal:controller.signal});
    updateVariant();
    if(optionsStatus)optionsStatus.hidden=optionsReady;
    if(needsOptions&&options&&!optionsReady){
      const readyObserver=new MutationObserver(()=>{
        if(!options.querySelector('.tcustomizer-field'))return;
        optionsReady=true;if(optionsStatus)optionsStatus.hidden=true;updateVariant();readyObserver.disconnect();
      });
      readyObserver.observe(options,{childList:true,subtree:true});observers.push(readyObserver);
    }
    mobileButton?.addEventListener('click',()=>{
      productForm.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      // Use the real button so Qikify's required-choice and surcharge handlers run.
      const activeButton=productForm.querySelector('.tcustomizer-overlap-button')||purchaseButton;
      if(!activeButton.disabled)activeButton.click();
    },{signal:controller.signal});
    if(mobileBar&&'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{mobileBar.hidden=entries[0].isIntersecting;},{threshold:0.5});observer.observe(purchaseButton);observers.push(observer);}
    if(mobileBar&&window.visualViewport){const handleKeyboard=()=>mobileBar.classList.toggle('keyboard-open',window.visualViewport.height<window.innerHeight*0.75);window.visualViewport.addEventListener('resize',handleKeyboard,{signal:controller.signal});}
    const recipient=productForm.querySelector('[data-gift-recipient]');
    if(recipient){
      recipient.hidden=false;
      const toggle=recipient.querySelector('[data-recipient-toggle]');
      const fields=recipient.querySelector('[data-recipient-fields]');
      const updateRecipient=()=>{fields.disabled=!toggle.checked;fields.hidden=!toggle.checked;};
      toggle.addEventListener('change',updateRecipient,{signal:controller.signal});updateRecipient();
    }
  }

  };
  initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',initialize);
})();
